import { makeStyles } from '@material-ui/core';

export const useStyle = makeStyles(theme => {
	const {
		palette,
		breakpoints: { down, up },
		spacing,
	} = theme;
	return {
		root: {
			color: palette.primary.main,
			fontFamily: 'Montserrat',
			display: 'flex',
			flexDirection: 'column',
			lineHeight: '30px',
			'& > h1 , h2': {
				fontFamily: 'BodoniMT',
				fontSize: '1.6rem',
				display: 'flex',
				alignItems: 'center',
				marginBottom: spacing(1),
				'&:not(:first-child)': {
					margin: spacing(3, 0, 1, 0),
					[down('sm')]: {
						margin: `${spacing(4, 0, 1, 0)} !important`,
					},
				},
				[down('sm')]: {
					fontSize: '1.4rem',
				},
			},
			'& p': {
				marginBottom: '10px',
			},
			'& > * img': {
				[up('sm')]: {
					float: 'left',
					margin: spacing(5),
					marginRight: '0',
				},
				[down('sm')]: {
					textAlign: 'left !important',
					width: '90%',
					margin: '2rem 5%',
				},
			},
			[down('sm')]: {
				lineHeight: '1.6rem',
				textAlign: 'left !important',
				'& p , li , h1 , h2 , h3': {
					textAlign: 'left !important',
				},
			},
		},
		square: {
			float: 'left',
			padding: '0',
			color: palette.action.main,
			width: 30,
			height: 30,
			transform: 'scale(1.2)',
			marginRight: '6px',
			marginLeft: '-5px',
			// [down('sm')]: {
			// 	width: 20,
			// 	height: 20,
			// },
		},
	};
});
